import { updateObject } from '../../shared/utility';
import { GET_AGENTS_IN_PRODUCT_START, GET_AGENTS_IN_PRODUCT_SUCCESS, GET_AGENTS_IN_PRODUCT_FAIL,
         CREATE_TRANSACTION_START, CREATE_TRANSACTION_SUCCESS, CREATE_TRANSACTION_FAIL,
        CLEAR_AGENTS_IN_PRODUCT  } from '../actions/actionTypes';

const initialState={
    agents:null,
    error:null,
    loading:false,
    message:null,
}

const getAgentsInProductStart=(state,action)=>{
    return updateObject(state,{error:null,message:null,loading:true});
}

const getAgentsInProductSuccess=(state,action)=>{
    return updateObject(state,{agents:action.agents,error:null,message:'get agents success',loading:false});
}

const getAgentsInProductFail=(state,action)=>{
    return updateObject(state,{error:action.error,message:null,loading:false});
}

const createTransactionStart=(state,action)=>{
    return updateObject(state,{error:null,message:null,loading:true});
}

const createTransactionSuccess=(state,action)=>{
    return updateObject(state,{error:null,message:action.message,loading:false});
}

const createTransactionFail=(state,action)=>{
    return updateObject(state,{error:action.error,message:null,loading:false});
}

const clearAgentsInProduct=(state,action)=>{
    return updateObject(state,{agents:null});
}

const transactionReducer=(state=initialState,action)=>{
    switch(action.type){
        case GET_AGENTS_IN_PRODUCT_START:
            return getAgentsInProductStart(state,action);
        case GET_AGENTS_IN_PRODUCT_SUCCESS:
            return getAgentsInProductSuccess(state,action);
        case GET_AGENTS_IN_PRODUCT_FAIL:
            return getAgentsInProductFail(state,action);
        case CREATE_TRANSACTION_START:
            return createTransactionStart(state,action);
        case CREATE_TRANSACTION_SUCCESS:
            return createTransactionSuccess(state,action);
        case CREATE_TRANSACTION_FAIL:
            return createTransactionFail(state,action);
        case CLEAR_AGENTS_IN_PRODUCT:
            return clearAgentsInProduct(state,action);
        default:
            return state;
    }
}

export default transactionReducer;